export default "__VITE_ASSET__672e4a51__"